import Env from "../../environments";
import { ROOT_GLOBAL } from "../../global/root";
import { Auth } from "../../models/auth";
import { LocalStorage } from "../../models/LocalStorage";
import { ELEMENT_TYPE, Track } from "../../utils/utils";

const $ = window.$;

export const setupUKPopup = () => {
  $("#uk-popup button").on("click", function () {
    window.location.href = Auth.callBackSignUp(ROOT_GLOBAL.UK_POPUP);
  });
  setUpTrack();
}

export const checkPopupUK = (countryCode) => {
  if (countryCode === Env.DUTY_CAST_UK_POPUP_COUNTRY || Env.DUTY_CAST_UK_POPUP_COUNTRY === "ALL") {
    showUKMenu();
    if (!LocalStorage.isLoggedIn() && !$(".modal.show").length) {
      showUKPopup();
    }
  }
}

export const showUKPopup = () => {
  // $("#uk-popup").modal("show");
}

export const showUKMenu = () => {
  $(".section-menu .uk-box").css("display", "block");
}

export const setUpTrack = () => {
  $("#uk-popup .box").attr("tfv", Track.genNormalTrack("", "uk-popup", "uk-popup", ELEMENT_TYPE.SECTION, "", 3000, 0, -1));
  $("#uk-popup .box").attr("tfr", Track.genNormalTrack("", "uk-popup", "uk-popup", ELEMENT_TYPE.SECTION, "", 3000, 0, 1));
  $("#uk-popup .box form button").attr("tfc", Track.genNormalTrack("", "uk-popup", "register", ELEMENT_TYPE.BUTTON, "", 3000, 0, 1));
  $("#uk-popup .box form button").attr("tfh", Track.genNormalTrack("", "uk-popup", "register", ELEMENT_TYPE.BUTTON, "", 3000, 0, 1));
}